import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import minusIcon from 'assets/images/icons/minus.svg';
import plusIcon from 'assets/images/icons/plus-grey-2.svg';

const PointerField = ({
  name,
  displayName,
  pointer,
  handleChange,
  withInput,
  shrink,
  classes,
  minWidth,
}) => {
  const { t } = useTranslation();
  const shrinkLabel = shrink ? ' shrink-label' : '';

  const onPointerChange = (value) => {
    if (!value) handleChange(name, 0);
    else if (value >= 0) handleChange(name, parseInt(value));
  };

  return (
    <div className={`custom-input-box ${classes ?? ''}`}>
      {displayName && <label className={shrinkLabel}>{t(displayName)}</label>}
      <div className={`custom-pointer-field${minWidth ? ' min-width' : ''}`}>
        <div
          className='d-flex justify-content-center align-items-center'
          onClick={() => onPointerChange(pointer - 1)}
        >
          <img src={minusIcon} />
        </div>
        {withInput ? (
          <input
            type='number'
            name={name}
            value={pointer}
            autoComplete='off'
            onChange={(e) => onPointerChange(e.target.value)}
            style={minWidth ? { width: `${String(pointer).length + 1}ch` } : {}}
          />
        ) : (
          <label>{pointer}</label>
        )}
        <div
          className='d-flex justify-content-center align-items-center'
          onClick={() => onPointerChange(pointer + 1)}
        >
          <img src={plusIcon} />
        </div>
      </div>
    </div>
  );
};

PointerField.propTypes = {
  name: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  pointer: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  withInput: PropTypes.bool,
  shrink: PropTypes.bool,
  classes: PropTypes.string,
  minWidth: PropTypes.bool,
};

export default PointerField;
